import { msg } from "../../../../locales/translate";
export const client_registration_form_step_1 = {
	model: {
		company_name: "",
		trading_company_name: "",
		reg_company_number: "",
		reg_date: 0,

		company_registration_address: {
			street: "",
			city: "",
			country: "",
			postal_code: "",
		},

		company_business_place: {
			street: "",
			city: "",
			country: "",
			postal_code: "",
		},

		business_description: "",

		required_license: "",
		$__required_license_values: ["Yes", "No"],

		license_number: "",
		$__license_number_linked: "required_license",
		$__license_number_linked_value: "Yes",

		license_issuer: "",
		$__license_issuer_linked: "required_license",
		$__license_issuer_linked_value: "Yes",

		license_issuer_country: "",
		$__license_issuer_country_linked: "required_license",
		$__license_issuer_country_linked_value: "Yes",
	},
};

export const client_registration_form_step_1_decorator = {
	model: {
		get $__company_name_label() { return msg("companyName"); },
		get $__trading_company_name_label() { return msg("tradingCompanyNameIfApplicable"); },
		get $__reg_company_number_label() { return msg("registrationNumber"); },
		get $__reg_date_label() { return msg("registrationDate"); },
		$__reg_date_type: "date",

		company_registration_address: {
			get $__street_label() { return msg("street"); },
			get $__city_label() { return msg("city"); },
			get $__country_label() { return msg("country"); },
			$__country_type: "country",
			get $__postal_code_label() { return msg("postalCode"); },
		},

		$__company_registration_address_decorator: {
			blockless: true,
			get title() { return msg("companyRegistrationAddress"); },
			gridTemplateColumns: "1fr 1fr",
		},

		company_business_place: {
			get $__street_label() { return msg("street"); },
			get $__city_label() { return msg("city"); },
			get $__country_label() { return msg("country"); },
			$__country_type: "country",
			get $__postal_code_label() { return msg("postalCode"); },
		},

		$__company_business_place_decorator: {
			blockless: true,
			get title() { return msg("companySPlaceOfBusinessIfDifferentFromRegistratered"); },
			gridTemplateColumns: "1fr 1fr",
		},

		get $__business_industry_label() { return msg("businessIndustryRequiredToHelpUsUnderstandYourCompanySActivi_045fc866"); },
		$__business_industry_type: "select",
		$__business_industry_values: [
				{
					get name() { return msg("assetManagementServices"); },
					value: "Asset management services",
				},
				{
					get name() { return msg("auctions"); },
					value: "Auctions",
				},
				{
					get name() { return msg("binaryOptions"); },
					value: "Binary options",
				},
				{
					get name() { return msg("consultingServices"); },
					value: "Consulting services",
				},
				{
					get name() { return msg("cryptocurrencyExchange"); },
					value: "Cryptocurrency exchange",
				},
				{
					get name() { return msg("digitalGoodsIncludingSkins"); },
					value: "Digital goods (including skins)",
				},
				{
					get name() { return msg("educationServices"); },
					value: "Education services",
				},
				{
					get name() { return msg("electronicMoneyInstitutionEmi"); },
					value: "Electronic money institution (EMI)",
				},
				{
					get name() { return msg("fileSharingHostingServices"); },
					value: "File sharing/hosting services",
				},
				{
					get name() { return msg("financialServices"); },
					value: "Financial services",
				},
				{
					get name() { return msg("foreignExchangeForex"); },
					value: "Foreign exchange (FOREX)",
				},
				{
					get name() { return msg("gamblingAndBetting"); },
					value: "Gambling and betting",
				},
				{
					get name() { return msg("gamesOfChanceRouletteWheelsPlayingCardsSpinningTopsDiceEtc"); },
					value: "Games of chance (roulette wheels, playing cards, spinning tops, dice, etc.)",
				},
				{
					get name() { return msg("intermediationInTrade"); },
					value: "Intermediation in trade",
				},
				{
					get name() { return msg("investmentServices"); },
					value: "Investment services",
				},
				{
					get name() { return msg("lendingServices"); },
					value: "Lending services",
				},
				{
					get name() { return msg("lotteryMarketingAndAdvertising"); },
					value: "Lottery marketing and advertising",
				},
				{
					get name() { return msg("multimediaServicesTextAudioImagesAnimationsVideoAndInteractiveContent"); },
					value: "Multimedia services (text, audio, images, animations, video and interactive content)",
				},
				{
					get name() { return msg("nonProfitServicesAssociationFundCharitableOrganizationEtc"); },
					value: "Non-profit services (association, fund, charitable organization, etc.)",
				},
				{
					get name() { return msg("onlineGaming"); },
					value: "Online gaming",
				},
				{
					get name() { return msg("preciousMetalAndStoneServices"); },
					value: "Precious metal and stone services",
				},
				{
					get name() { return msg("realEstate"); },
					value: "Real estate",
				},
				{
					get name() { return msg("socialNetworks"); },
					value: "Social networks",
				},
				{
					get name() { return msg("softwareSoftwareProvider"); },
					value: "Software/software provider",
				},
				{
					get name() { return msg("telecommunicationAndNetwork"); },
					value: "Telecommunication and network",
				},
				{
					get name() { return msg("tradeInformationTechnologiesIt"); },
					value: "Trade information technologies (IT)",
				},
				{
					get name() { return msg("transportationAndLogistics"); },
					value: "Transportation and logistics",
				},
				{
					get name() { return msg("ui_913b297658"); },
					value: "Travel/leisure",
				},
			],

		get $__required_license_label() { return msg("doesYourBusinessActivityRequireLicence"); },
		$__required_license_type: "radio",
		get $__license_file_label() { return msg("uploadLicenceCertificate"); },
		$__license_file_type: "file",

		get $__aml_regulation_label() { return msg("doesYourBusinessActivityRequireLicence"); },
		$__aml_regulation_type: "radio",
		get $__aml_document_label() { return msg("uploadAmlCtfPolicy"); },
		$__aml_document_type: "file",
		get $__mlro_document_label() { return msg("uploadMlroCv"); },
		$__mlro_document_type: "file",

		
	},

	$__model_decorator: {
        blockless: true,
		sx: { gap: "20px" },
		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["company_name", "trading_company_name"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["reg_company_number", "reg_date"],
			},
			{
				blockless: true,
				order: ["company_registration_address"],
			},
			{
				blockless: true,
				order: ["company_business_place"],
			},
			{
				blockless: true,
				order: ["business_industry"],
			},
			{
				blockless: true,
				order: ["required_license"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr",
				order: ["license_file"],
			},
			{
				blockless: true,
				order: ["aml_regulation"],
			},
			{
				blockless: true,
				order: ["aml_document"],
			},
			{
				blockless: true,
				order: ["mlro_document"],
			},
		],
	},
};
